
import React, { useContext, useEffect, useState } from 'react';
import { AdminContext } from '../AdminContext';

import { apiRequest } from '../../api/client';

// Helper to safely format ISO string for datetime-local input
function getInputValue(isoString) {
  if (!isoString) return '';
  const d = new Date(isoString);
  return isNaN(d) ? '' : d.toISOString().slice(0, 16);
}

export default function Dashboard() {
  const { user, token } = useContext(AdminContext);
  const [deadlines, setDeadlines] = useState({
    ceremonyDeadline: '',
    hackathonDeadline: '',
    volunteerDeadline: ''
  });
  const [newDeadlines, setNewDeadlines] = useState({
    ceremonyDeadline: '',
    hackathonDeadline: '',
    volunteerDeadline: ''
  });
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    async function fetchDeadlines() {
      try {
        const res = await apiRequest({
          method: 'get',
          url: '/api/admin-deadline',
          headers: { Authorization: `Bearer ${token}` }
        });
        setDeadlines(res.data);
        setNewDeadlines(res.data);
      } catch (err) {
        setMessage('Failed to fetch deadlines');
      }
    }
    fetchDeadlines();
  }, [token]);

  const handleChange = (e) => {
    setNewDeadlines({
      ...newDeadlines,
      [e.target.name]: new Date(e.target.value).toISOString()
    });
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage('');
    try {
      // Only send changed deadlines
      const updates = {};
      ['ceremonyDeadline', 'hackathonDeadline', 'volunteerDeadline'].forEach(key => {
        if (newDeadlines[key] && newDeadlines[key] !== deadlines[key]) {
          updates[key] = newDeadlines[key];
        }
      });
      if (Object.keys(updates).length === 0) {
        setMessage('No changes to save');
        setSaving(false);
        return;
      }
      const res = await apiRequest({
        method: 'post',
        url: '/api/admin-deadline',
        data: updates,
        headers: { Authorization: `Bearer ${token}` }
      });
      setDeadlines(res.data);
      setNewDeadlines(res.data);
      setMessage('Deadlines updated successfully');
    } catch (err) {
      setMessage('Failed to update deadlines');
    }
    setSaving(false);
  };

  return (
    <div style={{ maxWidth: 900, margin: '40px auto', padding: 24 }}>
      <h1>Admin Dashboard</h1>
      <div style={{ marginBottom: 24 }}>
        <strong>Welcome, {user?.email}</strong> <span style={{ color: '#888' }}>({user?.role})</span>
      </div>
      <div>
        <ul>
          <li>View and manage users</li>
          <li>View registrations</li>
          <li>Export data</li>
          <li>Change your password</li>
        </ul>
        {/* Add navigation or dashboard widgets here */}
      </div>
      <div style={{ marginTop: 40, padding: 20, border: '1px solid #ccc', borderRadius: 8 }}>
        <h2>Registration Deadlines</h2>
        <div style={{ marginBottom: 12 }}>
          <strong>Ceremony Deadline:</strong> {deadlines.ceremonyDeadline ? new Date(deadlines.ceremonyDeadline).toLocaleString() : 'Not set'}
          <br />
          <input
            type="datetime-local"
            name="ceremonyDeadline"
            value={getInputValue(newDeadlines.ceremonyDeadline)}
            onChange={handleChange}
            style={{ marginRight: 12, marginTop: 4 }}
          />
        </div>
        <div style={{ marginBottom: 12 }}>
          <strong>Hackathon Deadline:</strong> {deadlines.hackathonDeadline ? new Date(deadlines.hackathonDeadline).toLocaleString() : 'Not set'}
          <br />
          <input
            type="datetime-local"
            name="hackathonDeadline"
            value={getInputValue(newDeadlines.hackathonDeadline)}
            onChange={handleChange}
            style={{ marginRight: 12, marginTop: 4 }}
          />
        </div>
        <div style={{ marginBottom: 12 }}>
          <strong>Volunteer Deadline:</strong> {deadlines.volunteerDeadline ? new Date(deadlines.volunteerDeadline).toLocaleString() : 'Not set'}
          <br />
          <input
            type="datetime-local"
            name="volunteerDeadline"
            value={getInputValue(newDeadlines.volunteerDeadline)}
            onChange={handleChange}
            style={{ marginRight: 12, marginTop: 4 }}
          />
        </div>
        <button onClick={handleSave} disabled={saving}>
          {saving ? 'Saving...' : 'Save Deadlines'}
        </button>
        {message && <div style={{ marginTop: 10, color: message.includes('success') ? 'green' : 'red' }}>{message}</div>}
      </div>
    </div>
  );
}
